import React, { FC } from 'react';

import { OrganizationBadges, useMemberOrganizations } from 'components/badges/OrganizationBadges';
import { useCompanyProfile } from 'hooks/use-company-profile';
import { useIsMobile } from 'hooks/use-is-mobile';

import { useComponentContext } from '../../hooks/use-component-context';
import { BadgeGroup } from './BadgeGroup';

const Organizations: FC = () => {
    const { component } = useComponentContext();
    const { company } = useCompanyProfile(component.manufacturer);
    const isMobile = useIsMobile('sm');

    const memberOrganizations = useMemberOrganizations(company?.compliance);

    if (!memberOrganizations.length) {
        return null;
    }

    return (
        <BadgeGroup label="Member of">
            <OrganizationBadges organizations={memberOrganizations} size={isMobile ? 16 : undefined} />
        </BadgeGroup>
    );
};

export { Organizations };
